export function createSlug(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function isValidSlug(value) {
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value || '');
}

export const RESERVED_TENANT_SLUGS = new Set([
  'www',
  'admin',
  'api',
  'app',
  'auth',
  'mail',
  'support',
  'help',
  'dashboard',
  'billing',
  'status',
  'docs',
  'static',
  'assets',
  'cdn',
  'firebase',
  'functions',
  'accounts',
  'login',
  'register',
  'signup',
]);

export function isReservedTenantSlug(value) {
  return RESERVED_TENANT_SLUGS.has(String(value || '').trim().toLowerCase());
}

export function isValidTenantSlug(value) {
  const slug = String(value || '').trim().toLowerCase();
  return Boolean(slug)
    && slug.length <= 63
    && slug.length >= 2
    && isValidSlug(slug)
    && !isReservedTenantSlug(slug);
}

export function suggestTenantSlug(value) {
  return createSlug(value);
}
